<template>
  <div class="animated fadeIn">
    <loader :show="enviando" />
    <b-row>
      <b-col sm="12">
        <h4 style="text-align: center">
          10. VEHICULOS AUTOMOTORES, AERONAVES Y EMBARCACIONES DEL DECLARANTE,
          CÓNYUGE, CONCUBINA O CONCUBINARIO Y/O DEPENDIENTES ECONÓMICOS
        </h4>
      </b-col>
    </b-row>
    <b-list-group sm="12">
      <b-list-group-item v-for="(item, index) in arrVehiculos" :key="index">
        <b-col md="12">
          <div class="customHr">.</div>
        </b-col>
        <b-col md="12">
          <h5 style="text-align: center">Vehiculo</h5>
        </b-col>
        <b-col md="12">
          <div class="customHr">.</div>
        </b-col>
        <b-col md="12">
          <b-row>
            <b-col sm="3">
              <b-form-group label="Tipo Operación: ">
                <b-form-select
                :disabled="status === 'Concluida'"
                  :options="tipoOperacion"
                  v-model="item.tipoOperacion"
                  class="mb-3"
                ></b-form-select>
              </b-form-group>
            </b-col>
            <b-col md="3" v-if="item.tipoOperacion === 'BAJA'">
              <b-form-group label="Motivo Baja:">
                <b-form-select
                :disabled="status === 'Concluida'"
                  @change="seleccionaValorMotivoBaja(index)"
                  :options="motivo"
                  class="mb-3"
                  v-model="item.motivoBaja.clave"
                  text-field="valor"
                  value-field="clave"
                ></b-form-select>
              </b-form-group>
            </b-col>
            <b-col sm="3">
              <b-form-group label="Tipo de vehiculos: ">
                <b-form-select
                :disabled="status === 'Concluida'"
                  @change="seleccionaValorTipoVehiculo(index)"
                  :options="tipovehiculos"
                  v-model="item.tipoVehiculo.clave"
                  text-field="valor"
                  value-field="clave"
                  class="mb-3"
                ></b-form-select>
              </b-form-group>
            </b-col>
            <b-col sm="3">
              <b-form-group>
                <label>Marca:</label>
                <b-form-input
                :disabled="status === 'Concluida'"
                  @change="cambiosArrVehiculos[index].cambios = true"
                  type="text"
                  v-model="item.marca"
                  placeholder="Ingrese..."
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group>
                <label>Modelo:</label>
                <b-form-input
                :disabled="status === 'Concluida'"
                  @change="cambiosArrVehiculos[index].cambios = true"
                  type="text"
                  v-model="item.modelo"
                  placeholder="Ingrese..."
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group label="Año: ">
                <b-form-select
                :disabled="status === 'Concluida'"
                  @change="cambiosArrVehiculos[index].cambios = true"
                  :options="anio"
                  v-model="item.anio"
                  class="mb-3"
                >
                  <template v-slot:first>
                    <option :value="null">Selecciona </option>
                  </template></b-form-select
                >
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group>
                <label>Numero de serie o registro:</label>
                <b-form-input
                :disabled="status === 'Concluida'"
                  type="text"
                  @change="cambiosArrVehiculos[index].cambios = true"
                  v-model="item.numeroSerieRegistro"
                  placeholder="Ingrese..."
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col md="2">
              <b-form-group>
                <label>País:</label>
                <b-form-input
                  type="text"
                  v-model="item.lugarRegistro.pais"
                  placeholder="México"
                  disabled
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="Estado:">
                <b-form-select

                :disabled="status === 'Concluida'"
                  @change="seleccionaValorEstados(index)"
                  :options="estados"
                  v-model="item.lugarRegistro.entidadFederativa.clave"
                  text-field="valor"
                  value-field="clave"
                  class="mb-3"
                  >
 
                  </b-form-select
                >
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="Forma adquisición:">
                <b-form-select
                :disabled="status === 'Concluida'"
                  @change="seleccionaValorFormaAdquisicion(index)"
                  :options="adquisicion"
                  v-model="item.formaAdquisicion.clave"
                  text-field="valor"
                  value-field="clave"
                  class="mb-3"
                ></b-form-select>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="Forma de pago:">
                <b-form-select
                :disabled="status === 'Concluida'"
                  :options="formaPago"
                  @change="cambiosArrVehiculos[index].cambios = true"
                  v-model="item.formaPago"
                  text-field="valor"
                  class="mb-3"
                  ><template v-slot:first>
                    <option :value="null">Selecciona </option>
                  </template>
                  </b-form-select
                >
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="Fecha de adquisición:">
                <datetime
                :disabled="status === 'Concluida'"
                  :input-class="'form-control input'"
                  type="date"
                  placeholder="Selecciona fecha"
                  v-model="item.fechaAdquisicion"
                  @change="cambiosArrVehiculos[index].cambios = true"
                />
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group>
                <label>Monto:</label>
                <b-form-input
                :disabled="status === 'Concluida'"
                  type="text"
                  v-model="item.valorAdquisicion.valor"
                  @change="cambiosArrVehiculos[index].cambios = true"
                  placeholder="Ingrese..."
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group>
                <label>Tipo de moneda:</label>
                <b-form-input
                  type="text"
                  v-model="item.valorAdquisicion.moneda"
                  placeholder="MXN"
                  disabled
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
        <br />
        <!-- FIN formulario -->
        <br />
        <hr />
        <!---------------------- Titular------------------------------------>
        <b-col md="12">
          <b-col md="12">
            <h6>Titulares:</h6>
          </b-col>

          <b-list-group sm="12">
            <b-list-group-item
              v-for="(item_titular, i) in arrVehiculos[index].titular"
              :key="i"
            >
              <p style="text-align: center">{{ item_titular.valor }}</p>
              <b-row style="text-align: center">
                <b-col>
                  <b-button
                  v-if="status !== 'Concluida'"
                    variant="danger"
                    size="sm"
                    @click="eliminarTitular(index)"
                    >Eliminar titular</b-button
                  >
                </b-col>
              </b-row>
            </b-list-group-item>
            <br />
            <b-modal
              v-model="mostrar"
              title="Nuevo titular"
              cancel-title="Cancelar"
              ok-title="Generar"
              @ok="nuevoTitular(index)"
              v-if="status !== 'Concluida'"
            >
              <b-form-select v-model="tmpTitular" :options="t"></b-form-select>
            </b-modal>
          </b-list-group>
          <b-col md="12">
            <b-button  v-if="status !== 'Concluida'" variant="primary" size="sm" @click="mostrar = true"
              >Agregar Titular</b-button
            >
          </b-col>
        </b-col>
        <br />
        <!---------------------- Transmisor------------------------------------>
        <b-col sm="12">
          <b-col md="12">
            <h6>Transmisores:</h6>
          </b-col>
          <b-list-group sm="12">
            <b-list-group-item
              v-for="(item_transmisor, index_transmisor) in arrVehiculos[index]
                .transmisor"
              :key="index_transmisor"
            >
              <b-col md="12">
                <b-row>
                  <b-col md="2">
                    <b-form-group label="Parentezco con el declarante:">
                      <b-form-select
                      :disabled="status === 'Concluida'"
                        @change="
                          seleccionaValorParentesco(index, index_transmisor)
                        "
                        :options="relacion"
                        class="mb-3"
                        v-model="item_transmisor.relacion.clave"
                        text-field="valor"
                        value-field="clave"
                      ></b-form-select>
                    </b-form-group>
                  </b-col>
                  <b-col md="2">
                    <b-form-group label="Tipo de persona:">
                      <b-form-select
                      :disabled="status === 'Concluida'"
                        :options="tipoPersona"
                        text-field="valor"
                        v-model="item_transmisor.tipoPersona"
                        class="mb-3"
                      ></b-form-select>
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group>
                      <label>RFC:</label>
                      <b-form-input
                      :disabled="status === 'Concluida'"
                        type="text"
                        v-model="item_transmisor.rfc"
                        placeholder="Ingrese..."
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group>
                      <label>Razón Social:</label>
                      <b-form-input
                      :disabled="status === 'Concluida'"
                        type="text"
                        v-model="item_transmisor.nombreRazonSocial"
                        placeholder="Ingrese..."
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="4" style="text-align: center">
                    <b-button
                    v-if="status !== 'Concluida'"
                      variant="primary"
                      @click="
                        guardarTransmisor(
                          item_transmisor._id,
                          index,
                          index_transmisor
                        )
                      "
                      :disabled="enviando"
                      size="sm"
                      >Guardar cambios</b-button
                    >
                    <br />
                  </b-col>
                  <br />
                  <b-col md="6" class="text-right">
                    <b-button
                    :disabled="status === 'Concluida'"
                      variant="danger"
                      size="sm"
                      @click="eliminarTransmisor(index_transmisor, index)"
                      >Eliminar transmisor</b-button
                    >
                  </b-col>
                </b-row>
              </b-col>
            </b-list-group-item>
          </b-list-group>
          <br />
          <b-col md="12">
            <b-button
             v-if="status !== 'Concluida'"
              variant="primary"
              size="sm"
              @click="nuevoTransmisor(index)"
              >Agregar transmisor</b-button
            >
          </b-col>
        </b-col>
        <br />
        <!---------------------- Tercero------------------------------------>
        <b-col sm="12">
          <b-col md="12">
            <h6>Terceros:</h6>
          </b-col>
          <b-list-group sm="12">
            <b-list-group-item
              v-for="(item_tercero, index_tercero) in arrVehiculos[index]
                .tercero"
              :key="index_tercero"
            >
              <b-col md="12">
                <b-row>
                  <b-col md="2">
                    <b-form-group label="Tipo de persona:">
                      <b-form-select
                      :disabled="status === 'Concluida'"
                        :options="tipoPersona"
                        v-model="item_tercero.tipoPersona"
                        class="mb-3"
                      ></b-form-select>
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group>
                      <label>Razón Social:</label>
                      <b-form-input
                      :disabled="status === 'Concluida'"
                        type="text"
                        v-model="item_tercero.nombreRazonSocial"
                        placeholder="Ingrese..."
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group>
                      <label>RFC:</label>
                      <b-form-input
                      :disabled="status === 'Concluida'"
                        type="text"
                        v-model="item_tercero.rfc"
                        placeholder="Ingrese..."
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="6" style="text-align: center">
                    <b-button
                    v-if="status !== 'Concluida'"
                      variant="primary"
                      @click="
                        guardarTercero(item_tercero._id, index, index_tercero)
                      "
                      :disabled="enviando"
                      size="sm"
                      >Guardar cambios</b-button
                    >
                    <br />
                  </b-col>
                  <br />
                  <b-col md="6" style="text-align: center">
                    <b-button
                    v-if="status !== 'Concluida'"
                      variant="danger"
                      size="sm"
                      @click="eliminarTercero(index_tercero, index)"
                      >Eliminar tercero</b-button
                    >
                  </b-col>
                </b-row>
              </b-col>
            </b-list-group-item>
          </b-list-group>
          <br />
          <b-col md="12">
            <b-button  v-if="status !== 'Concluida'" variant="primary" size="sm" @click="nuevoTercero(index)"
              >Agregar tercero</b-button
            >
          </b-col>
        </b-col>
        <br />
        <br />
        <!------------------------------------------------Fin Tercero---------->

        <b-col md="12">
          <b-row style="text-align: center">
            <b-col>
              <b-button
              v-if="status !== 'Concluida'"
                variant="primary"
                size="sm"
                @click="modificarVehiculo(index)"
                >Guardar vehiculo</b-button
              >
              <p v-if="cambiosArrVehiculos[index].cambios" class="error-text">
                <i>No se han guardado los cambios</i>
              </p>
            </b-col>

            <b-col>
              <b-button
              v-if="status !== 'Concluida'"
                variant="danger"
                size="sm"
                @click="eliminarvehiculo(index)"
                >Eliminar vehiculo</b-button
              >
            </b-col>
          </b-row>
        </b-col>
      </b-list-group-item>
    </b-list-group>

    <br />
    <b-row>
      <b-col md="12">
        <b-button v-if="status !== 'Concluida'" variant="primary" size="sm" @click="nuevoElemento()"
          >Agregar Vehiculo</b-button
        >
      </b-col>
    </b-row>
    <br />

    <b-row>
      <b-col md="12">
        <b-form-group>
          <label>ACLARACIONES / OBSERVACIONES</label>
          <b-form-input
          :disabled="status === 'Concluida'"
            @change="cambios = true"
            type="text"
            v-model="vehiculos.aclaracionesObservaciones"
            placeholder="Ingrese..."
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

     
    <br />
    <br />
    <b-row>
      <b-col md="4">
        <b-button variant="success" @click="verSeccion(0)" :disabled="enviando"
          >Regresar al índice</b-button
        >
      </b-col>
      <b-col md="4" style="text-align: center">
        <b-button
        v-if="status !== 'Concluida'"
          variant="primary"
          @click="actualizarAclaraciones()"
          :disabled="enviando"
          >Guardar cambios</b-button
        >
        <br />
        <p v-show="cambios" class="error-text">
          <i>No se han guardado los cambios</i>
        </p>
      </b-col>
      <b-col md="2">
        <b-button
    
          variant="secondary"
          @click="verSeccion(9)"
          :disabled="enviando"
          >Anterior</b-button
        >
      </b-col>
      <b-col md="2">
        <b-button
 
          class="pull-right"
          variant="secondary"
          @click="verSeccion(11)"
          :disabled="enviando"
          >Siguiente</b-button
        >
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import swal from "sweetalert";
import Loader from "../../../views/Loader";
import { mapGetters } from "vuex";

import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
import { paises } from "../../../store/paises";
import { log } from "util";

export default {
  props: ["vehiculos", "status"],
  components: {
    Datetime,
    Loader
  },
  computed: {
    ...mapGetters(["httpURL", "sessionToken"])
  },
  data: function() {
    return {
      arrVehiculos: [],
      cambiosArrVehiculos: [],
      banderaEditar: false,
      titulo: this.$route.name,

      cambios: false,

      relacionClave: "",
      relacionNombre: "",
      enviando: false,
      pais: paises,
      contadorVehiculo: 0,
      contador: 0,
      contador2: 0,
      contador3: 0,
      moneda: ["MXN"],
      tipoOperacion: ["AGREGAR", "MODIFICAR", "BAJA", "SIN_CAMBIOS"],
      motivo: [
        { clave: "VNT", valor: "VENTA" },
        { clave: "DNC", valor: "DONACIÓN" },
        { clave: "SNT", valor: "SINIESTRO" },
        { clave: "OTRO", valor: "OTRO" }
      ],
      tipovehiculos: [
        { clave: "AUTMOT", valor: "AUTOMÓVIL/MOTOCICLETA" },
        { clave: "AERN", valor: "AERONAVE" },
        { clave: "BRCYTE", valor: "BARCO/YATE" },
        { clave: "OTRO", valor: "OTRO" }
      ],
      tmpTitular: "",
      mostrar: false,
      t: [
        "DECLARANTE",
        "CONYUGE",
        "CONCUBINA O CONCUBINARIO",
        "CONVIVIENTE",
        "DEPENDIENTE ECONÓMICO",
        "COPROPIEDAD CON TERCEROS"
      ],
      titularindex: [
        { clave: "DEC", valor: "DECLARANTE" },
        { clave: "CYG", valor: "CONYUGE" },
        { clave: "CBN", valor: "CONCUBINA O CONCUBINARIO" },
        { clave: "CVV", valor: "CONVIVIENTE" },
        { clave: "DEN", valor: "DEPENDIENTE ECONÓMICO" },
        { clave: "CTER", valor: "COPROPIEDAD CON TERCEROS" }
      ],
      tipoPersona: ["FISICA", "MORAL"],
      relacion: [
        { clave: "ABU", valor: "ABUELO(A)" },
        { clave: "NIE", valor: "NIETO(A)" },
        { clave: "TIOA", valor: "TIO(A)" },
        { clave: "AHI", valor: "AHIJADO(A)" },
        { clave: "NUE", valor: "NUERA" },
        { clave: "YER", valor: "YERNO" },
        { clave: "CUN", valor: "CUÑADO(A)" },
        { clave: "PAD", valor: " PADRE" },
        { clave: "HER", valor: "HERMANO(A)" },
        { clave: "PRI", valor: "PRIMO(A)" },
        { clave: "HIJ", valor: "HIJO(A)" },
        { clave: "SOB", valor: "SOBRINO(A)" },
        { clave: "MAD", valor: "MADRE" },
        { clave: "SUE", valor: "SUEGRO(A)" },
        { clave: "BISA", valor: "BISABUELO(A)" },
        { clave: "BISN", valor: "BISNIETO(A)" },
        { clave: "CONB", valor: "CONCUBINA O CONCUBINARIO" },
        { clave: "CONC", valor: "CONCUÑO(A)" },
        { clave: "CONY", valor: "CÓNYUGE" },
        { clave: "TATA", valor: "TATARABUELO(A)" },
        { clave: "TATN", valor: "TATARANIETO(A)" },
        { clave: "NIN", valor: "NINGUNO" },
        { clave: "OTRO", valor: "OTRO(ESPECIFIQUE)" }
      ],
      adquisicion: [
        { clave: "CPV", valor: "COMPRAVENTA" },
        { clave: "CSN", valor: "CESIÓN" },
        { clave: "DNC", valor: "DONACIÓN" },
        { clave: "HRN", valor: "HERENCIA" },
        { clave: "PRM", valor: "PERMUTA" },
        { clave: "RST", valor: "RIFA O SORTEO" },
        { clave: "STC", valor: "SENTENCIA" }
      ],
      formaPago: [
        { valor: "CRÉDITO" },
        { valor: "CONTADO" },
        { valor: "NO APLICA" }
      ],
      estados: [

        { clave: "01", valor: "AGUASCALIENTES" },
        { clave: "02", valor: "BAJA CALIFORNIA" },
        { clave: "03", valor: "BAJA CALIFORNIA SUR" },
        { clave: "04", valor: "CAMPECHE" },
        { clave: "05", valor: "COAHUILA DE ZARAGOZA" },
        { clave: "06", valor: "COLIMA" },
        { clave: "07", valor: "CHIAPAS" },
        { clave: "08", valor: "CHIHUAHUA" },
        { clave: "09", valor: "DISTRITO FEDERAL" },
        { clave: "10", valor: "DURANGO" },
        { clave: "11", valor: "GUANAJUATO" },
        { clave: "12", valor: "GUERRERO" },
        { clave: "13", valor: "HIDALGO" },
        { clave: "14", valor: "JALISCO" },
        { clave: "15", valor: "MéXICO" },
        { clave: "16", valor: "MICHOACÁN DE OCAMPO" },
        { clave: "17", valor: "MORELOS" },
        { clave: "18", valor: "NAYARIT" },
        { clave: "19", valor: "NUEVO LEÓN" },
        { clave: "20", valor: "OAXACA" },
        { clave: "21", valor: "PUEBLA" },
        { clave: "22", valor: "QUERÉTARO" },
        { clave: "23", valor: "QUINTANA ROO" },
        { clave: "24", valor: "SAN LUIS POTOSÍ" },
        { clave: "25", valor: "SINALOA" },
        { clave: "26", valor: "SONORA" },
        { clave: "27", valor: "TABASCO" },
        { clave: "28", valor: "TAMAULIPAS" },
        { clave: "29", valor: "TLAXCALA" },
        { clave: "30", valor: "VERACRUZ DE IGNACIO DE LA LLAVE" },
        { clave: "31", valor: "YUCATÁN" },
        { clave: "32", valor: "ZACATECAS" }
      ],
      anio: [
        "1950",
        "1951",
        "1952",
        "1953",
        "1954",
        "1955",
        "1956",
        "1957",
        "1958",
        "1959",
        "1960",
        "1961",
        "1962",
        "1963",
        "1964",
        "1965",
        "1966",
        "1967",
        "1968",
        "1969",
        "1970",
        "1971",
        "1972",
        "1973",
        "1974",
        "1975",
        "1976",
        "1977",
        "1978",
        "1979",
        "1980",
        "1981",
        "1982",
        "1983",
        "1984",
        "1985",
        "1986",
        "1987",
        "1989",
        "1989",
        "1990",
        "1991",
        "1992",
        "1993",
        "1994",
        "1995",
        "1996",
        "1997",
        "1998",
        "1999",
        "2000",
        "2001",
        "2002",
        "2003",
        "2004",
        "2005",
        "2006",
        "2007",
        "2008",
        "2009",
        "2010",
        "2011",
        "2012",
        "2013",
        "2014",
        "2015",
        "2016",
        "2017",
        "2018",
        "2019",
        "2020",
        "2021"
      ]
    };
  },
  methods: {
    //*****************************SeleccionValor*******************************************
    seleccionaValorTipoVehiculo(index) {
      let indice = this.tipovehiculos.findIndex(
        x => x.clave == this.arrVehiculos[index].tipoVehiculo.clave
      );
      this.arrVehiculos[index].tipoVehiculo.valor = this.tipovehiculos[
        indice
      ].valor;
    },
    seleccionaValorEstados(index) {
      let indice = this.estados.findIndex(
        x =>
          x.clave ==
          this.arrVehiculos[index].lugarRegistro.entidadFederativa.clave
      );
      this.arrVehiculos[
        index
      ].lugarRegistro.entidadFederativa.valor = this.estados[indice].valor;
    },
    seleccionaValorFormaAdquisicion(index) {
      let indice = this.adquisicion.findIndex(
        x => x.clave == this.arrVehiculos[index].formaAdquisicion.clave
      );
      this.arrVehiculos[index].formaAdquisicion.valor = this.adquisicion[
        indice
      ].valor;
    },
    seleccionaValorMotivoBaja(index) {
      let indice = this.motivo.findIndex(
        x => x.clave == this.arrVehiculos[index].motivoBaja.clave
      );
      this.arrVehiculos[index].motivoBaja.valor = this.motivo[indice].valor;
    },
    seleccionaValorTitular(index, index_titular) {
      let indice = this.titularindex.findIndex(
        x => x.clave == this.arrVehiculos[index].titular[index_titular].clave
      );
      this.arrVehiculos[index].titular[index_titular].valor = this.titularindex[
        indice
      ].valor;
    },
    seleccionaValorParentesco(index, index_transmisor) {
      let indice = this.relacion.findIndex(
        x =>
          x.clave ==
          this.arrVehiculos[index].transmisor[index_transmisor].relacion.clave
      );
      this.arrVehiculos[index].transmisor[
        index_transmisor
      ].relacion.valor = this.relacion[indice].valor;
    },

    //*****************************Titular*******************************************
    nuevoTitular(index) {
      let indice = this.titularindex.findIndex(x => x.valor == this.tmpTitular);
      let nuevoTitular = {
        clave: this.titularindex[indice].clave,
        valor: this.tmpTitular
      };
      this.arrVehiculos[index].titular.push(nuevoTitular);
  

      axios
        .post(
          this.httpURL +
            "/declaraciones/V2/vehiculos/" +
            this.$route.params.id +
            "/vehiculo/" +
            this.arrVehiculos[index]._id +
            "/titular",
          {
            titularClave: this.titularindex[indice].clave,
            titularValor: this.tmpTitular
          },
          { headers: { token: this.sessionToken } }
        )
        .then(res => {
       
          this.banderaEditar = true;
          this.$notify({
            group: "foo",
            type: "success",
            duration: 2500,
            speed: 1000,
            text: res.data.mensaje
          });
          this.arrVehiculos[index].titular[index_titular]._id =
            res.data.titular._id;
          this.enviando = false;
        })
        .catch(error => {
          if (error.response) {
            this.$notify({
              group: "foo",
              type: "error",
              duration: 2500,
              speed: 1000,
              text: error.response.data.mensaje
            });
          } else if (error.request) {
            this.$notify({
              group: "foo",
              type: "error",
              duration: 2500,
              speed: 1000,
              text: "No se pudo establecer una conexión al servidor."
            });
          }
          this.enviando = false;
        });
    },

    eliminarTitular(index) {
      swal({
        text: "¿Está seguro en eliminar el titular?",
        buttons: true,
        dangerMode: true
      }).then(willDelete => {
        if (willDelete) {
          axios
            .delete(
              this.httpURL +
                "/declaraciones/V2/vehiculos/" +
                this.$route.params.id +
                "/vehiculo/" +
                this.arrVehiculos[index]._id +
                "/titular/" +
                this.arrVehiculos[index].titular[index]._id,
              { headers: { token: this.sessionToken } }
            )
            .then(res => {
             
              this.arrVehiculos[index].titular.splice(index, 1);
              if (res.data.ok == true) {
                this.$notify({
                  group: "foo",
                  type: "success",
                  duration: 2500,
                  speed: 1000,
                  text: res.data.mensaje
                });
              }
              this.enviando = false;
            })
            .catch(error => {
              this.$notify({
                group: "foo",
                type: "error",
                duration: 2500,
                speed: 1000,
                text: "No se pudo guardar la sección."
              });
              this.enviando = false;
            
            });
        }
      });
    },
    //*****************************Tercero*******************************************
    nuevoTercero(index) {
      let nuevoTercero = {
        _id: this.contador2,
        tipoPersona: null,
        nombreRazonSocial: null,
        rfc: null
        // relacion: { valor: this.terceroValor }
      };
      this.arrVehiculos[index].tercero.push(nuevoTercero);
      this.contador2++;
    },
    guardarTercero(id, index, index_tercero) {
      if (id < 100) {
        axios
          .post(
            this.httpURL +
              "/declaraciones/V2/vehiculos/" +
              this.$route.params.id +
              "/vehiculo/" +
              this.arrVehiculos[index]._id +
              "/tercero",
            {
              tipoPersona: this.arrVehiculos[index].tercero[index_tercero]
                .tipoPersona,
              nombreRazonSocial: this.arrVehiculos[index].tercero[index_tercero]
                .nombreRazonSocial,
              rfc: this.arrVehiculos[index].tercero[index_tercero].rfc
            },
            { headers: { token: this.sessionToken } }
          )
          .then(res => {
        
            this.banderaEditar = true;
            this.$notify({
              group: "foo",
              type: "success",
              duration: 2500,
              speed: 1000,
              text: res.data.mensaje
            });
            this.arrVehiculos[index].tercero[index_tercero]._id =
              res.data.tercero._id;
            this.enviando = false;
          })
          .catch(error => {
            if (error.response) {
              this.$notify({
                group: "foo",
                type: "error",
                duration: 2500,
                speed: 1000,
                text: error.response.data.mensaje
              });
            } else if (error.request) {
              this.$notify({
                group: "foo",
                type: "error",
                duration: 2500,
                speed: 1000,
                text: "No se pudo establecer una conexión al servidor."
              });
            }
            this.enviando = false;
          });
      } else {
        axios
          .put(
            this.httpURL +
              "/declaraciones/V2/vehiculos/" +
              this.$route.params.id +
              "/vehiculo/" +
              this.arrVehiculos[index]._id +
              "/tercero/" +
              id,
            {
              tipoPersona: this.arrVehiculos[index].tercero[index_tercero]
                .tipoPersona,
              nombreRazonSocial: this.arrVehiculos[index].tercero[index_tercero]
                .nombreRazonSocial,
              rfc: this.arrVehiculos[index].tercero[index_tercero].rfc
            },
            { headers: { token: this.sessionToken } }
          )
          .then(res => {
           
            if (res.data.ok == true) {
              this.$notify({
                group: "foo",
                type: "success",
                duration: 2500,
                speed: 1000,
                text: res.data.mensaje
              });
            }
            this.enviando = false;
            this.cambios = false;
          })
          .catch(error => {
            this.$notify({
              group: "foo",
              type: "error",
              duration: 2500,
              speed: 1000,
              text: "No se pudo crear nuevo titular."
            });
            this.enviando = false;
          });
      }
    },
    eliminarTercero(i, index) {
      swal({
        text: "¿Está seguro en eliminar tercero?",
        buttons: true,
        dangerMode: true
      }).then(willDelete => {
        if (willDelete) {
          axios
            .delete(
              this.httpURL +
                "/declaraciones/V2/vehiculos/" +
                this.$route.params.id +
                "/vehiculo/" +
                this.arrVehiculos[index]._id +
                "/tercero/" +
                this.arrVehiculos[index].tercero[index]._id,
              { headers: { token: this.sessionToken } }
            )
            .then(res => {
             
              this.arrVehiculos[index].tercero.splice(index, 1);
              if (res.data.ok == true) {
                this.$notify({
                  group: "foo",
                  type: "success",
                  duration: 2500,
                  speed: 1000,
                  text: res.data.mensaje
                });
              }
              this.enviando = false;
            })
            .catch(error => {
              this.$notify({
                group: "foo",
                type: "error",
                duration: 2500,
                speed: 1000,
                text: "No se pudo guardar la sección."
              });
              this.enviando = false;
       
            });
        }
      });
    },
    //*****************************Transmisor*******************************************
    nuevoTransmisor(index) {
      let nuevoTransmisor = {
        _id: this.contador3,
        relacion: { clave: null, valor: null },
        tipoPersona: null,
        nombreRazonSocial: null,
        rfc: null
      };
      this.arrVehiculos[index].transmisor.push(nuevoTransmisor);
      this.contador3++;
    },
    guardarTransmisor(id, index, index_transmisor) {
      if (id < 100) {
        axios
          .post(
            this.httpURL +
              "/declaraciones/V2/vehiculos/" +
              this.$route.params.id +
              "/vehiculo/" +
              this.arrVehiculos[index]._id +
              "/transmisor",
            {
              tipoPersona: this.arrVehiculos[index].transmisor[index_transmisor]
                .tipoPersona,
              relacionClave: this.arrVehiculos[index].transmisor[
                index_transmisor
              ].relacion.clave,
              relacionValor: this.arrVehiculos[index].transmisor[
                index_transmisor
              ].relacion.valor,
              nombreRazonSocial: this.arrVehiculos[index].transmisor[
                index_transmisor
              ].nombreRazonSocial,
              rfc: this.arrVehiculos[index].transmisor[index_transmisor].rfc
            },
            { headers: { token: this.sessionToken } }
          )
          .then(res => {
           
            this.banderaEditar = true;
            this.$notify({
              group: "foo",
              type: "success",
              duration: 2500,
              speed: 1000,
              text: res.data.mensaje
            });
            this.arrVehiculos[index].transmisor[index_transmisor]._id =
              res.data.transmisor._id;
            this.enviando = false;
          })
          .catch(error => {
            if (error.response) {
              this.$notify({
                group: "foo",
                type: "error",
                duration: 2500,
                speed: 1000,
                text: error.response.data.mensaje
              });
            } else if (error.request) {
              this.$notify({
                group: "foo",
                type: "error",
                duration: 2500,
                speed: 1000,
                text: "No se pudo establecer una conexión al servidor."
              });
            }
            this.enviando = false;
          });
      } else {
        axios
          .put(
            this.httpURL +
              "/declaraciones/V2/vehiculos/" +
              this.$route.params.id +
              "/vehiculo/" +
              this.arrVehiculos[index]._id +
              "/transmisor/" +
              id,
            {
              tipoPersona: this.arrVehiculos[index].transmisor[index_transmisor]
                .tipoPersona,
              relacionClave: this.arrVehiculos[index].transmisor[
                index_transmisor
              ].relacion.clave,
              relacionValor: this.arrVehiculos[index].transmisor[
                index_transmisor
              ].relacion.valor,
              nombreRazonSocial: this.arrVehiculos[index].transmisor[
                index_transmisor
              ].nombreRazonSocial,
              rfc: this.arrVehiculos[index].transmisor[index_transmisor].rfc
            },
            { headers: { token: this.sessionToken } }
          )
          .then(res => {
          
            if (res.data.ok == true) {
              this.$notify({
                group: "foo",
                type: "success",
                duration: 2500,
                speed: 1000,
                text: res.data.mensaje
              });
            }
            this.enviando = false;
          })
          .catch(error => {
            this.$notify({
              group: "foo",
              type: "error",
              duration: 2500,
              speed: 1000,
              text: "No se pudo crear nuevo titular."
            });
            this.enviando = false;
          });
      }
    },

    eliminarTransmisor(index_transmisor, index) {
      swal({
        text: "¿Está seguro en eliminar tercero?",
        buttons: true,
        dangerMode: true
      }).then(willDelete => {
        if (willDelete) {
          axios
            .delete(
              this.httpURL +
                "/declaraciones/V2/vehiculos/" +
                this.$route.params.id +
                "/vehiculo/" +
                this.arrVehiculos[index]._id +
                "/transmisor/" +
                this.arrVehiculos[index].transmisor[index]._id,
              { headers: { token: this.sessionToken } }
            )
            .then(res => {
              this.arrVehiculos[index].transmisor.splice(index, 1);
              if (res.data.ok == true) {
                this.$notify({
                  group: "foo",
                  type: "success",
                  duration: 2500,
                  speed: 1000,
                  text: res.data.mensaje
                });
              }
              this.enviando = false;
            })
            .catch(error => {
              this.$notify({
                group: "foo",
                type: "error",
                duration: 2500,
                speed: 1000,
                text: "No se pudo guardar la sección."
              });
              this.enviando = false;
              
            });
        }
      });
    },

    //*******************************AclaracionesObservaciones********************************** */

    actualizarAclaraciones() {
      this.enviando = true;
      axios
        .put(
          this.httpURL +
            "/declaraciones/V2/vehiculos/" +
            this.$route.params.id +
            "/aclaracionesObservaciones",
          {
            aclaracionesObservaciones: this.vehiculos.aclaracionesObservaciones,
            ninguno: ""
          },
          { headers: { token: this.sessionToken } }
        )
        .then(res => {
        
          if (res.data.ok == true) {
            this.$notify({
              group: "foo",
              type: "success",
              duration: 2500,
              speed: 1000,
              text: res.data.mensaje
            });
          }
          this.enviando = false;
          this.cambios = false;
        })
        .catch(error => {
          this.$notify({
            group: "foo",
            type: "error",
            duration: 2500,
            speed: 1000,
            text: "No se pudo guardar la sección."
          });
          this.enviando = false;
        });
    },

    //*****************************Vehiculo*******************************************
    nuevoElemento() {
      axios
        .post(
          this.httpURL +
            "/declaraciones/V2/vehiculos/" +
            this.$route.params.id +
            "/vehiculo",
          {},
          { headers: { token: this.sessionToken } }
        )
        .then(res => {
         
          let objeto = { _id: this.contadorVehiculo, cambios: false };
          this.cambiosArrVehiculos.push(objeto);
          this.arrVehiculos.push(res.data.vehiculo);
          this.contadorVehiculo++;
          this.enviando = true;
         
          if (res.data.ok == true) {
            this.$notify({
              group: "foo",
              type: "success",
              duration: 2500,
              speed: 1000,
              text: res.data.mensaje
            });
            //this.arrVehiculos.vehiculo.push(res.data.vehiculo);
          }
          this.enviando = false;
          // this.cambios = false;
        })
        .catch(error => {
          this.$notify({
            group: "foo",
            type: "error",
            duration: 2500,
            speed: 1000,
            text: "No se pudo crear nuevo elemento."
          });
          this.enviando = false;
        });
    },

    modificarVehiculo(index) {
      this.enviando = true;
      axios
        .put(
          this.httpURL +
            "/declaraciones/V2/vehiculos/" +
            this.$route.params.id +
            "/vehiculo/" +
            this.arrVehiculos[index]._id,
          {
            tipoOperacion: this.arrVehiculos[index].tipoOperacion,
            tipoVehiculoClave: this.arrVehiculos[index].tipoVehiculo.clave,
            tipoVehiculoValor: this.arrVehiculos[index].tipoVehiculo.valor,
            marca: this.arrVehiculos[index].marca,
            modelo: this.arrVehiculos[index].modelo,
            anio: this.arrVehiculos[index].anio,
            numeroSerieRegistro: this.arrVehiculos[index].numeroSerieRegistro,
            lugarRegistroPais: this.arrVehiculos[index].lugarRegistro.pais,
            entidadFederativaClave: this.arrVehiculos[index].lugarRegistro
              .entidadFederativa.clave,
            entidadFederativaValor: this.arrVehiculos[index].lugarRegistro
              .entidadFederativa.valor,
            formaAdquisicionClave: this.arrVehiculos[index].formaAdquisicion
              .clave,
            formaAdquisicionValor: this.arrVehiculos[index].formaAdquisicion
              .valor,
            formaPago: this.arrVehiculos[index].formaPago,
            valorAdquisicionValor: this.arrVehiculos[index].valorAdquisicion
              .valor,
            valorAdquisicionMoneda: this.arrVehiculos[index].valorAdquisicion
              .moneda,
            fechaAdquisicion: this.arrVehiculos[index].fechaAdquisicion,
            motivoBajaClave: this.arrVehiculos[index].motivoBaja.clave,
            motivoBajaValor: this.arrVehiculos[index].motivoBaja.valor
          },
          { headers: { token: this.sessionToken } }
        )
        .then(res => {
       
        
          if (res.data.ok == true) {
            this.$notify({
              group: "foo",
              type: "success",
              duration: 2500,
              speed: 1000,
              text: res.data.mensaje
            });
            this.enviando = false;
            this.cambiosArrVehiculos[index].cambios = false;
          }
        })
        .catch(error => {
          this.$notify({
            group: "foo",
            type: "error",
            duration: 2500,
            speed: 1000,
            text: "No se pudo guardar la sección."
          });
          this.enviando = false;
        });
    },
    eliminarvehiculo(index) {
      swal({
        text: "¿Está seguro en eliminar el vehiculo?",
        icon: "warning",
        buttons: true,
        dangerMode: true
      }).then(willDelete => {
        if (willDelete) {
          axios
            .delete(
              this.httpURL +
                "/declaraciones/V2/vehiculos/" +
                this.$route.params.id +
                "/vehiculo/" +
                this.vehiculos.vehiculo[index]._id,
              { headers: { token: this.sessionToken } }
            )
            .then(res => {
            
              if (res.data.ok == true) {
                this.$notify({
                  group: "foo",
                  type: "success",
                  duration: 2500,
                  speed: 1000,
                  text: res.data.mensaje
                });
                this.arrVehiculos.splice(index, 1);
                this.cambiosArrVehiculos.splice(index, 1);
              }
              this.enviando = false;
            })
            .catch(error => {
              this.$notify({
                group: "foo",
                type: "error",
                duration: 2500,
                speed: 1000,
                text: "No se pudo guardar la sección."
              });
              this.enviando = false;
            
            });
        }
      });
    },

    /********************************************************************************************/

    verSeccion(sec) {
      this.$emit("verSeccion", sec);
    },
    checarCambios(item, indice) {
      let index = this.cambiosArrVehiculos.findIndex(x => x._id == item._id);
      return this.cambiosArrVehiculos[indice].cambios;
      //return false;
    },
    seRealizaronCambios(item) {
      let index = this.cambiosArrVehiculos.findIndex(x => x._id == item._id);
      this.cambiosArrVehiculos[index].cambios = true;
    }
  },
  created() {
   

    this.arrVehiculos = this.vehiculos.vehiculo;
    this.vehiculos.vehiculo.forEach(Element => {
      let objeto = { _id: Element._id, cambios: false };
      this.cambiosArrVehiculos.push(objeto);
      if (Element.tipoOperacion === "AGREGAR") {
        Element.tipoOperacion = "MODIFICAR";
      }
    });
   
  }
};
</script>

<style>
.customHr {
  width: 100%;
  font-size: 1px;
  color: rgba(0, 0, 0, 0);
  line-height: 1px;

  background-color: grey;
  margin-top: 0px;
  margin-bottom: 10px;
}
.error-texr {
  color: #ff0000;
}
</style>
